<template>
    <div class="Inner">
        <input class="js-no-data-curve" type="hidden" :value="WebsiteService.getCurvePath('BP470')"
            data-curve-color="#00AEEF" data-curve-slug="bp470" data-curve-title="BP470"
            :data-curve-permalink="WebsiteService.getCurvePermalink('BP470')">
        <input class="js-no-data-curve" type="hidden" :value="WebsiteService.getCurvePath('BN532')"
            data-curve-color="#8EC640" data-curve-slug="bn532" data-curve-title="BN532"
            :data-curve-permalink="WebsiteService.getCurvePermalink('BN532')">
        <div class="columns">
            <div class="curve-compare-chart-wrap">
                <div id="js-curve-compare-chart" class="curve-compare-chart px-5"></div>
                <div class="curve-compare-chart-nodata js-curve-compare-chart-nodata">
                    <h2 class="curve-compare-chart-nodata-title">Find the right filter for your application</h2>
                    <div>
                        <span class="curve-compare-chart-nodata-subtitle">
                            <strong>1</strong> - Select filters below (up to 5)
                        </span>
                    </div>
                    <div>
                        <span class="curve-compare-chart-nodata-subtitle">
                            <strong>2</strong> - Hover over curves to view data
                        </span>
                    </div>
                    <div>
                        <span class="curve-compare-chart-nodata-subtitle">
                            <strong>3</strong> - Contact us about filter selections
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import $ from 'jquery';
import Highcharts from 'highcharts';
import { useAppStore } from '@/stores/app';
import { useRoute, useRouter } from 'vue-router';
import { useChartStore } from '@/stores/highcharts';
import { onMounted, ref, computed, reactive, onUnmounted } from 'vue';
import jsPDF from "jspdf";
import 'svg2pdf.js'
import * as htmlToImage from 'html-to-image';
import { loadImageAsDataUrl } from '@/utils/helpers';
import QueueService from '@/services/queue';
import pdfLogo from '@/assets/logo4.png';
import WebsiteService from '@/services/website';

const route = useRoute();
const router = useRouter();
const appStore = useAppStore();
const chartStore = useChartStore();

const urlArray = ref([]);
let chart = reactive({});
const mptcc = reactive({});

const options = computed(() => ({
    chart: {
        renderTo: 'js-curve-compare-chart',
        type: 'line',
        // backgroundColor: 'grey',
        backgroundColor: 'transparent',
        spacingBottom: 15,
        spacingTop: 30,
        spacingLeft: 10,
        spacingRight: 40,
        height: 700,
        animation: true,
        reflow: true
    },
    exporting: {
        allowHTML: true
    },
    title: {
        text: ''
    },
    series: chartStore.dataArray,
    tooltip: {
        shared: true,
        crosshairs: true,
        backgroundColor: 'none',
        borderColor: 'none',
        borderWidth: 0,
        shadow: false,
        formatter: function () {
            $.each(this.points, function (i, point) {
                var seriesName = point.series.name,
                    seriesSlug = seriesName.toLowerCase(),
                    seriesSlug = seriesSlug.replace(/\W/g, '');
                var seriesColor = point.color,
                    seriesY = point.y,
                    seriesX = point.x;
                chartStore.currentWavelength = seriesX;
                chartStore.seriesValues[seriesName] = { w: seriesX, t: seriesY };
            });
        }
    },
    xAxis: {
        min: 190,
        max: null,
        tickInterval: 100,
        title: {
            text: '',
            // text: 'Wavelength(nm)',
        },
        labels: {
            rotation: 45,
            style: {
                fontWeight: '900',
                fontSize: '1.5rem'
            },
        },
    },
    yAxis: {
        min: 0,
        max: 100,
        tickInterval: 20,
        title: {
            text: '',
            // text: 'Transmission(%)',
        },
        labels: {
            style: {
                fontWeight: '900',
                fontSize: '1.5rem'
            },
        },
    },
    plotOptions: {
        series: {
            lineWidth: 5,
            states: {
                inactive: {
                    opacity: 1,
                },
            },
        },
        line: {
            states: {
                hover: {
                    lineWidth: 0,
                    lineWidthPlus: 0
                }
            },
            marker: {
                enabled: false,
            },
        }
    },
    legend: {
        enabled: false
    },
    credits: {
        enabled: false
    },
    lang: {
        weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        exportButtonTitle: 'Export chart',
        downloadPNG: 'Download PNG image',
        downloadPDF: 'Download PDF document',
        printChart: 'Print chart',
        viewFullscreen: 'View in full screen',
        resetZoom: 'Reset zoom',
        resetZoomTitle: 'Reset zoom level 1:1',
        thousandsSep: ',',
        decimalPoint: '.',
        numericSymbols: ['k', 'M', 'B', 'T', 'P', 'E'],
    }
}));

onUnmounted(() => {
    // chartStore.clearAll();
    $(document).off("click", ".js-tab");
    $(document).off("click", ".js-print");
    $(document).off("click", ".js-curve-sort");
    $(document).off("click", ".js-lightsource");
    $(document).off("click", ".js-group-filter");
    $(document).off("click", ".js-clear-curves");
    $(document).off("click", ".js-curve-contact");
    $(document).off("click", ".js-curve-compare-screenshot-btn");
});

onMounted(() => {
    chartStore.init();
    mptcc.init();
});

mptcc.init = function () {
    // mptcc.reset();
    mptcc.columns();
    mptcc.filtering();
    mptcc.curves();
    mptcc.lightsources();
    mptcc.actions();
    mptcc.tabs();
}

mptcc.reset = function () {
    chartStore.curveCounter = 0;
    chartStore.lightCounter = 0;
    chartStore.nodata = true;
    $(".js-curve-compare-chart-nodata").fadeIn(500);
}

mptcc.tabs = function () {
    $(document).on("click", ".js-tab", function (e) {
        e.preventDefault;
        var thisTab = $(this).data("tab");

        $(".js-tab").removeClass("is-current");
        $(this).addClass("is-current");

        $(".js-tab-block").hide();
        $("#" + thisTab).show();
    });
}

mptcc.actions = function () {
    $(document).on("click", ".js-print", function (e) {
        e.preventDefault;
        window.print();
    });
}

mptcc.columns = function () {
    // Split all of the filters into 6 columns
    var $groups = $(".js-groups > .js-group"),
        $thresh = Math.ceil($groups.length / 5),
        $last = 0;

    for (var i = 0; i < $groups.length; i += $thresh) {
        $last = i + $thresh;
        $groups.slice(i, $last).wrapAll($("<div />").addClass("group-column"));
    }

    // Split all of the LEDs into 2 columns
    var $groups = $(".js-leds-columns > .js-lightsource"),
        $thresh = Math.ceil($groups.length / 2),
        $last = 0;

    for (var i = 0; i < $groups.length; i += $thresh) {
        $last = i + $thresh;
        $groups.slice(i, $last).wrapAll($("<div />").addClass("leds-column"));
    }

    // Split all of the Lasers into 4 columns
    var $groups = $(".js-lasers-columns > .js-lightsource"),
        $thresh = Math.ceil($groups.length / 6),
        $last = 0;

    for (var i = 0; i < $groups.length; i += $thresh) {
        $last = i + $thresh;
        $groups.slice(i, $last).wrapAll($("<div />").addClass("lasers-column"));
    }
}

mptcc.filtering = function () {
    $(document).on("click", ".js-curve-sort", function (e) {
        e.preventDefault();

        $(this).toggleClass("on");

        var thisGroup = $(this).attr("data-href");

        // Handle "Show All"
        if (thisGroup == "show-all") {
            $(".js-curve-sort").removeClass("on");
            $(".js-curve-sort[data-href=show-all]").addClass("on");

            $(".js-group").removeClass("_disabled");
        } else {
            $(".js-curve-sort[data-href=show-all]").removeClass("on");
            mptcc.checkGroups(thisGroup);
        }
    });
}

mptcc.checkGroups = function (thisGroup) {
    var clickedGroup = thisGroup;

    $(".js-group").addClass("_disabled");

    $(".js-curve-sort").each(function () {
        if ($(this).hasClass("on")) {
            $(".js-group[data-category=" + $(this).attr("data-href") + "]").removeClass("_disabled");
        }
    });
}

mptcc.lightsources = function () {
    $(document).on("click", ".js-lightsource", function (e) {
        e.preventDefault();
        var lightsourceImg = $(this).attr("data-image"),
            slug = $(this).attr("data-slug"),
            ghostOverlay = "",
            lightsourceType = $(this).attr("data-lightsource-type"),
            xPosition = $(this).attr("data-x-position");

        if (chartStore.lightCounter < 5) {
            ghostOverlay = "<span class='lightsource-overlay _x" + xPosition + " _" + lightsourceType + " js-lightsource-overlay-" + slug + "' style='background-image: url(" + lightsourceImg + ")'>" + slug + "</span>";

            $("#js-curve-compare-chart").append(ghostOverlay);

            chartStore.lightCounter++;
        } else {
            alert("You have a maximum of 5 Light Sources.");
        }
    });
}

mptcc.curves = function () {
    chart = new Highcharts.Chart(options.value);

    // var curveCompareData = $(".js-curve-compare-data > table > tbody");

    if (chartStore.curveCounter > 0) {
        $(".js-curve-compare-chart-nodata").fadeOut(500);
    }

    if (chartStore.curveCounter == 0) {
        $(".js-no-data-curve").each(async function () {
            var curveTitle = $(this).data("curve-title"),
                curveSlug = $(this).data("curve-slug"),
                jsonPath = $(this).val(),
                curveColor = $(this).data("curve-color"),
                curvePermalink = $(this).data("curve-permalink"),
                tempObject = {};

            tempObject.id = curveSlug;
            tempObject.color = curveColor;
            tempObject.name = curveTitle;
            tempObject.permalink = curvePermalink;
            tempObject.marker = {
                states: {
                    hover: {
                        enabled: true,
                        fillColor: curveColor,
                        lineColor: curveColor,
                        lineWidth: 0,
                        lineWidthPlus: 0
                    }
                },
                radius: 1,
                lineWidth: 0,
                symbol: 'circle'
            };

            WebsiteService.getPathData(jsonPath).then((response) => {
                if (response.status === 200) {
                    const data = response.data.reverse();
                    // tempObject.data = data;
                    chart.addSeries(tempObject);
                }
            });
        });
    }

    $(document).on("click", ".js-curve-compare-screenshot-btn", async function (e) {
        e.preventDefault();
        var offset = 0;
        var selectors = $(this).attr('data-selectors');

        if (!selectors.length) return;

        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'pt',
            format: 'a4'
        });

        try {
            appStore.createEmailLoading = true;
            appStore.sendEmailBlocked = true;

            // Parse the JSON string to get the array of selectors
            const selectorArray = JSON.parse(selectors);

            // Load PNG image from assets
            const dataUrl = await loadImageAsDataUrl(pdfLogo);

            // Add PNG image from assets to PDF
            pdf.addImage(dataUrl, 'PNG', 150, 50 + offset, 300, 80); // Adjust position and dimensions as needed
            offset += 150; // Adjust offset as needed

            for (let i = 0; i < selectorArray.length; i++) {
                const selector = selectorArray[i];

                const dataUrl = await htmlToImage.toPng($(selector.name)[0]);
                pdf.addImage(dataUrl, 'PNG', 50, 50 + offset, selector.width, selector.height);
                offset += selector.height + 50;
            }
            const fileBlob = pdf.output('blob');
            const formData = new FormData();
            const filename = `${appStore.screenNumber}_${route.meta.title.replace(' ', '')}.pdf`;
            formData.append('pdf', new Blob([fileBlob], { type: 'application/pdf' }), filename);
            QueueService.putIntoQueue(formData, '/screen').then((response) => {
                appStore.createEmailLoading = false;
            });
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    });

    $(document).on("click", ".js-group-filter", function (e, index) {
        e.preventDefault();
        var curveTitle = $(this).data("curve-title"),
            curveSlug = $(this).data("curve-slug"),
            jsonPath = $(this).data("curve-json-path"),
            curvePermalink = $(this).data("permalink");

        if (!$(this).hasClass("_enabled")) {
            if (chartStore.curveCounter < 5) {

                if (chartStore.nodata === true) {
                    chartStore.nodata = false;
                    $(".js-curve-compare-chart-nodata").fadeOut(500);
                    while (chart.series.length > 0) {
                        chart.series[0].remove(false);
                    }
                    chart.redraw();
                }

                var curveColor = chartStore.curveColors.splice(0, 1).toString();

                $(this).toggleClass("_enabled");
                $(this).attr("data-curve-color", curveColor);

                $.ajax({
                    url: jsonPath,
                    dataType: 'json',
                    success: function (data) {
                        data = data.reverse();

                        var tempObject = {};

                        tempObject.id = curveSlug;
                        tempObject.data = data;
                        tempObject.color = curveColor;
                        tempObject.name = curveTitle;
                        tempObject.permalink = curvePermalink;
                        tempObject.marker = {
                            states: {
                                hover: {
                                    enabled: true,
                                    fillColor: curveColor,
                                    lineColor: curveColor,
                                    lineWidth: 0,
                                    lineWidthPlus: 0
                                }
                            },
                            radius: 1,
                            lineWidth: 0,
                            symbol: 'circle'
                        };
                        chart.addSeries(tempObject);
                        chartStore.addSeries(tempObject, chart);
                        chartStore.enableItem(curveTitle);
                        chartStore.curveCounter++;

                        $(".js-curvecomparedata-hidden").append();
                    },
                    error: function () {
                        if (!chartStore.curveCounter) mptcc.reset();
                        router.push(`/filters?link=https://midopt.com/filters/${curveTitle}/`);
                    }
                });
                urlArray.value.push(curveTitle);
            } else {
                alert("You have a maximum of 5 Data Curves.");
            }
        } else {
            $(this).removeClass("_enabled");
            var tempColor = $(this).attr("data-curve-color").toString();
            chartStore.curveColors.push(tempColor);
            $(this).attr("data-curve-color", "");

            $(".js-curve-compare-data").find("tr." + curveSlug).remove();

            chart.get(curveSlug).remove();
            chartStore.disableItem(curveTitle);
            chartStore.curveCounter--;

            if (chartStore.curveCounter === 0) {
                if (chartStore.nodata === false) {
                    chartStore.nodata = true;
                    $(".js-curve-compare-chart-nodata").fadeIn(500);
                }
            }

            var urlArrayIndex = urlArray.value.indexOf(curveTitle);
            chartStore.romeveItem(urlArrayIndex, curveTitle);
            urlArray.value.splice(urlArrayIndex, 1);
        }
    });

    $(document).on("click", ".js-clear-curves", function (e) {
        e.preventDefault();

        chartStore.initColors();

        // Remove series from chart
        while (chart.series.length > 0) {
            chart.series[0].remove(false);
        }
        chart.redraw();

        // Remove classes from Filters
        $(".js-group-filter").removeClass("_enabled");

        // Clear legend table
        $(".js-curve-legend").html("");

        $(".js-curve-compare-chart-nodata").fadeIn(500);

        // Reset Curve Counter
        chartStore.curveCounter = 0;
        chartStore.lightCounter = 0;
        chartStore.nodata = true;
    });

    $(document).on("click", ".js-curve-contact", function (e) {
        e.preventDefault();
        var urlString = urlArray.value.toString();

        var loc = location.href;
        // loc += loc.indexOf("?") === -1 ? "?" : "&";
        var loc = "/contact-us/curve-compare/?chosenCCFilters=" + urlString;
        // location.href = loc + "?filters=" + urlParams;
        // location.href = loc;

        var win = window.open(loc, '_blank');
        win.focus();
    });
}

</script>

<style scoped>
.Inner {
    margin: 0 auto;
    padding: 0 15px;
    position: relative;
    width: 100%;
    /* max-width: 1010px; */
}

.curve-compare-chart-wrap {
    position: relative;
    width: 100%;
    display: inline-block;
    letter-spacing: normal;
    word-spacing: normal;
    vertical-align: top;
    text-rendering: auto;
    overflow: hidden;
}

.curve-compare-chart-nodata {
    position: absolute;
    top: 43%;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    text-align: center;
}
</style>